import React from "react";
import { TFunction } from "i18next";
import { useDispatch } from "react-redux";

import { removeArrayOfObjectsDuplicates } from "@helpers/general";

import { AppDispatch } from "../../../../redux/store";
import {
    setSelectedFidelity,
    setIsSupportCodeValid,
    shopSelectionSynced,
} from "../../../../redux/slices/fidelitySlice";

type Deps = {
    t: TFunction;
    selectedRows: ShopsFidelityShop[];
    dataTable: ShopsFidelityData;
    setIsShopSelected: (v: boolean) => void;
    isModalOpenedSupport: boolean;
    isValidCode: boolean;
    codeSupport: string;
};

export function useShopsFidelitySync({
    t,
    selectedRows,
    dataTable,
    setIsShopSelected,
    isModalOpenedSupport,
    isValidCode,
    codeSupport,
}: Deps) {
    const dispatch = useDispatch<AppDispatch>();

    React.useEffect(() => {
        const localShop: string[] = [];
        const idsLocalShop: string[] = [];
        const associatedFidelity: FidelityRow[] = [];
        const rowShop: ShopsFidelityShop[] = [];
        Object.values(selectedRows).forEach((el: ShopsFidelityShop) => {
            if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined) {
                localShop.push(el.shopId);
                rowShop.push(el);
                for (const i in el.subRows) {
                    idsLocalShop.push(el.subRows[i].Id);
                    associatedFidelity.push(el.subRows[i]);
                }
            }
        });

        dispatch(
            shopSelectionSynced({
                associatedFidelity,
                rowsShop: rowShop,
                idsLocalShop,
                localShop,
                shopsFidelityData: dataTable,
            })
        );
        setIsShopSelected(localShop.length !== 0);
    }, [selectedRows, dataTable, t, setIsShopSelected, dispatch]);

    React.useEffect(() => {
        const array: Record<string, string>[] = [];
        selectedRows.forEach((element: ShopsFidelityShop & { Id?: string }) => {
            if (element[t("Shop")] !== undefined) {
                (element.subRows as FidelityRow[]).forEach((el: FidelityRow) => {
                    array.push({ [el.shopId]: el.Id });
                });
            } else {
                array.push({ [element.shopId as string]: element.Id as string });
            }
        });
        dispatch(setSelectedFidelity(removeArrayOfObjectsDuplicates(array)));
    }, [selectedRows, t, dispatch]);

    React.useEffect(() => {
        dispatch(
            setIsSupportCodeValid(
                !isModalOpenedSupport &&
                    isValidCode === false &&
                    codeSupport !== ""
            )
        );
    }, [isModalOpenedSupport, isValidCode, codeSupport, dispatch]);
}
